import React from 'react';
import { useTranslation } from 'react-i18next';

import MediaTypography from 'components/MediaTypography';

import TabletChecksIcon from '@common/assets/icons/tablet-checks-icon.svg';
import { INotificationsModel } from '@common/models/Notifications/Notifications';
import { IServicesModel } from '@common/models/Services/Services';

import { ButtonWrapper } from './styled';

interface IProps {
	notifications: INotificationsModel;
	services: IServicesModel;
}

function MarkAllAsReadButton({ notifications, services }: IProps) {
	const { t } = useTranslation();

	const isDisabled = notifications.loading || notifications.unreadCount === 0;
	return (
		<ButtonWrapper
			disabled={isDisabled}
			onClick={
				isDisabled
					? undefined
					: () =>
							notifications.readAll({
								status: 'read',
								query: {
									service_id: services.current.id,
								},
							})
			}
		>
			<TabletChecksIcon style={{ width: '24px', height: '25px', color: 'inherit' }} />
			<MediaTypography variant="subtitle2" variants={{ sm: 'subtitle3' }}>
				{t('notifications.markAllAsRead')}
			</MediaTypography>
		</ButtonWrapper>
	);
}

export default MarkAllAsReadButton;
